import DOMPurify from 'dompurify';
import { useLayoutEffect, useRef } from 'react';

const ALLOWED_TAGS = ['p', 'br', 'strong', 'em', 'ul', 'ol', 'li', 'a', 'h3', 'h4', 'span'];
const ALLOWED_ATTR = ['href', 'target', 'rel'];

export function SafeHtml({
  html,
  className,
}: {
  html: string;
  className?: string;
}): JSX.Element {
  const ref = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    if (!ref.current) return;
    const fragment = DOMPurify.sanitize(html, {
      ALLOWED_TAGS,
      ALLOWED_ATTR,
      RETURN_DOM_FRAGMENT: true,
    }) as DocumentFragment;
    ref.current.replaceChildren(fragment);
  }, [html]);
  return <div ref={ref} className={className} />;
}
